<template>
  <div>
    <!--  头部模板  -->
    <header-yjj></header-yjj>
    <header-img-yjj></header-img-yjj>
    <div class="container">
      <p class="nav">当前位置：首页——缅怀英烈</p>

      <div class="content">
        <h2>缅怀英烈</h2>
        <div style="margin-top: 20px;">
          <img src="https://zbhk-new.lnyun.com.cn/www/huanren/images/202307/533633632871387345.png" style="width:100%">
        </div>
      </div>

      <div class="memory">
        <h3>
          <span style="border-right: 1px solid white;margin-right: 2px;"></span>
          <span style="border-right: 3px solid white;margin-right: 5px;"></span>
          网上祭扫
        </h3>
        <div class="memory-content" >
          <div class="col" v-for="item in memoryList" :key="item.index" >
            <div  >
              <div class="bg" @click="addPv(item.id,item.pv)">
                <div style="display: flex">
                  <div style="flex: 1">
                    <img :src="item.imgsrc" style="width:100%">
                  </div>
                  <div style="flex: 1;padding: 30px 0;font-weight: bold;line-height: 20px">
                    <p>{{ item.name }}</p>
                    <p>{{ item.pv + item.setpv }}</p>
                  </div>
                </div>
              </div>
            </div>

          </div>
<!-- -->
        </div>
      </div>

    </div>

    <!--  底部模板  -->
    <footer-yjj></footer-yjj>
  </div>
</template>

<script>
import HeaderYjj from "@/components/yjj/HeaderYjj";
import FooterYjj from "@/components/yjj/FooterYjj";
import HeaderImgYjj from "@/components/yjj/HeaderImgYjj";
import {request} from "@/request/request";
export default {
  name: "MemoryYjj",
  components:{
    HeaderYjj,
    FooterYjj,
    HeaderImgYjj
  },
  data(){
    return{
      memoryList:[],
      restfulUrl:'memory',
      notcol:{}
    }
  },
  methods:{
    addPv:function(uid,upv){
      var updataPv = {
        id:uid,
        pv:upv+1
      }
      this.updateOneById(updataPv);

    },
    getData:function(){//获取全部数据
      request({
        method:'GET',
        url:this.restfulUrl,
      }).then(res =>{
        if(res.code==1){
          this.memoryList = res.data;
        }
      },err=>{
        console.log(err)
      })
    },
    updateOneById:function(data){
      request({
        method:'PUT',
        url:'/memory',
        data:data
      }).then(res =>{
        if(res.code==1){
          this.getData();
        }
      },err=>{
        console.log(err)
      })
    },
  },
  mounted() {
    this.getData();
  },
  metaInfo() {
    return {
      title: this.$route.meta.title || 'My Vue App'
    };
  }
}
</script>

<style scoped>
.container{
  width:70%;
  margin: 0 auto;
  padding:10px 0;
}
.nav{
  text-align: left;
}
.content{
  margin: 40px auto 0;
}
.content h2{
  margin: 0 auto;
  padding:20px 0;
  border-bottom: 1px solid silver;
}
.memory{
  text-align: left;
  padding-bottom: 50px;
}
.memory h3{
  background: #9E1A28;
  padding:20px;
  color: white;
}
.memory-content{
  background: rgb(241,231,223);
  height: 120px;
  display: flex;
  padding:20px;
}
.memory-content .col{
  flex: 1;
  padding: 10px;
}
.memory-content .col .bg{
  height:120px;
  background: white;
  cursor: pointer;
}

.active{
  border-bottom: 4px solid #FFECB2;
}
</style>
